import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import GlobalAppSettings from './GlobalAppSettings';

const mapStateToProps = (state: any) => ({
  settings: state.trackerSettings.global.settings,
  isLoading: state.trackerSettings.global.isLoading,
  failed: state.trackerSettings.global.failed,
});

export const ConnectedGlobalAppSettings = connect(
  mapStateToProps, null,
)(GlobalAppSettings);

export default withTranslation(['administration'])(ConnectedGlobalAppSettings as any);
